/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { cn } from '@express-labs/raven-tools';

import ProductImage from '../ProductImage';

import s from './MegaMenuCategoryImages.module.scss';

function MegaMenuCategoryImages({
  className, containerClassName, showImages, images,
}) {
  const [isCached, setIsCached] = useState(false);

  /* Cache the rendered images.
   * For performance, if the the parent nav item is not expaned, the component will not be rendered
   */
  useEffect(() => {
    if (showImages && !isCached) setIsCached(true);
  }, [isCached, showImages]);

  if (isCached) {
    return (
      <aside className={containerClassName}>
        {images?.map(({
          image: imageSrc, imageAltText, title, url,
        }) => (
          <ProductImage
            key={imageSrc}
            className={cn(className, s.categoryImage)}
            imageSrc={imageSrc}
            imageAlt={imageAltText}
            imageHref={url}
            description={title}
          />
        ))}
      </aside>
    );
  }

  return null;
}

MegaMenuCategoryImages.propTypes = {
  containerClassName: PropTypes.string,
  className: PropTypes.string,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      imageAltText: PropTypes.string,
      title: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
  showImages: PropTypes.bool,
};

export default MegaMenuCategoryImages;
